import { makeStyles } from "@material-ui/core/styles";

export default function ProdutoCardCss() {
    return makeStyles((theme) => ({
        root: {
            backgroundColor: theme.palette.secondary.background,
            width: "100%",
            padding: "10px",
            paddingLeft: "30px",
        },
        calendar: {
            maxWidth: "50%",
        },
    }));
}
